import v17Schema, {
  MigrationTypes as V17Types,
} from "../client/schemaVersions/v17.js";
import v18Schema, {
  MigrationTypes as V18Types,
} from "../client/schemaVersions/v18.js";
import { createMigration } from "@verdant-web/store";

export default createMigration<V17Types, V18Types>(
  v17Schema,
  v18Schema,
  async ({ migrate }) => {
    // add or modify migration logic here. you must provide migrations for
    // any collections that have changed field types or added new non-nullable
    // fields without defaults
    // await migrate('collectionName', async (old) => ({ /* new */ }));
  },
);
